import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import AthleteLayout from "../common/AthleteLayout";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import API_URL from "../../api/API";

export const AthleteSpeedWorkout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { athlete } = useAthleteAuthContext();
  const { product_id } = useParams();

  const productFromState = location.state?.product_basic;
  const [product, setProduct] = useState(productFromState || null);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    if (!productFromState) {
      const fetchProduct = async () => {
        try {
          const response = await fetch(
            `${API_URL.FRONTEND_ATHLETE_PURCHASED_SPEED_PRODUCT_DETAIL}${athlete.id}/${product_id}`,
            { headers: { Authorization: `Bearer ${athlete.token}` } },
          );
          const json = await response.json();
          if (response.ok) setProduct(json.data);
        } catch (err) {
          console.error(err);
        }
      };
      fetchProduct();
    }
  }, []);

  const toggleAccordion = (index) =>
    setOpenIndex(openIndex === index ? null : index);

  const handleWarmupClick = () => {
    navigate(`/athlete/speed-product/warmup-routine-phases/${product._id}`, {
      state: { product_basic: product },
    });
  };

  return (
    <AthleteLayout>
      <div className="flex flex-col h-full bg-white">
        <div className="flex-1 overflow-y-auto">
          {/* Header */}
          <div className="pb-3 mb-3 w-full max-w-2xl mx-auto flex flex-row justify-center items-center gap-10 px-5">
            <p className="w-full py-3 text-black text-xl line-clamp-2 leading-tight text-center border-b border-black/30">
              {product?.title || "Product"}
            </p>
          </div>

          <div className="w-full max-w-2xl mx-auto">
            {/* Tabs */}
            <div className="px-5 mb-4">
              <div className="bg-[#f5f4f4] rounded-2xl flex justify-between gap-8 px-4 py-4">
                <button
                  onClick={handleWarmupClick}
                  className="text-lightSmock text-sm xs:text-base"
                >
                  Warmup 
                </button>
                <button className="text-black text-sm xs:text-base">
                   Workout
                </button>
              </div>
            </div>

            {/* Scrollable content */}
            <div className="space-y-5 px-5">
              {product?.speed_training_template?.length > 0 ? (
                product.speed_training_template.map((week, weekIndex) => (
                  <div
                    key={weekIndex}
                    className={`${openIndex === weekIndex ? "!border-black/30" : ""} border border-transparent rounded-xl`}
                  >
                    <button
                      className="w-full flex justify-between items-center gap-5 text-white text-base font-bold bg-black text-left px-4 py-3 rounded-lg"
                      onClick={() => toggleAccordion(weekIndex)}
                    >
                      <span>Week {weekIndex + 1}</span>
                      <span
                        className={`transform transition-transform duration-300 flex justify-center items-center bg-darkYellow p-1 text-black leading-none w-6 h-6 text-center`}
                      >
                        {openIndex === weekIndex ? <Minus /> : <Plus />}
                      </span>
                    </button>

                    {openIndex === weekIndex && (
                      <div className="px-10 py-3">
                        {Object.entries(week.days || {})
                          .filter(([dayName, day]) => day?.sprints?.length > 0)
                          .map(([dayName, day], dayIndex) => (
                            <div
                              key={dayIndex}
                              className="w-fit flex justify-between items-center"
                            >
                              <button
                                onClick={() =>
                                  navigate(
                                    `/athlete/speed-product/speed-workout/sprints/${product._id}`,
                                    {
                                      state: {
                                        product_basic: product,
                                        weekNumber: week.weekNumber,
                                        dayName,
                                        sprints: day.sprints,
                                      },
                                    },
                                  )
                                }
                                className="w-full py-1 text-left text-sm font-medium text-black capitalize border-b-2 border-transparent hover:border-darkYellow"
                              >
                                {`${dayName.charAt(0).toUpperCase() + dayName.slice(1)}:  ${day.training_focus || "Training Focus"}`}
                              </button>
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p className="text-center text-black mt-5">
                  No speed training template found.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </AthleteLayout>
  );
};


const Plus = () => {
  return (
    <svg
      width="24" className="w-full h-full"
      height="24"
      viewBox="0 0 24 24"
      fill="none" preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H24V24H0V0Z" fill="#C19E42" />
      <path d="M11 4.5H13V19.5H11V4.5Z" fill="black" />
      <path d="M4.5 13V11H19.5V13H4.5Z" fill="black" />
    </svg>
  );
};

const Minus = () => {
  return (
    <svg
      width="24" className="w-full h-full"
      height="24"
      viewBox="0 0 24 24"
      fill="none" preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H24V24H0V0Z" fill="#C19E42" />
      {/* <path d="M10.5 4H13.5V20H10.5V4Z" fill="black" /> */}
      <path d="M4.5 13V11H19.5V13H4.5Z" fill="black" />
    </svg>
  );
};